export default () => {
  return Math.random().toString(36).slice(2, 34);
};
